import Module from 'epa-components-platform/src/lib/helper/js/Module';
import helperDOM from 'epa-components-platform/src/lib/helper/js/helperDOM';

export class NotificationBase extends Module {
  constructor(el) {
    super();

    this.el = el;
  }

  show = () => {
    helperDOM.addClass(this.el, 'shown')
  }

  close = () => {
    helperDOM.removeClass(this.el, 'shown');
  }
}